import React, { Component } from 'react'
import cn from 'classnames'
import isEqual from 'react-fast-compare'
import { TableCell, TextField } from '@material-ui/core'

export class SourcesCells extends Component {
  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props, nextProps)
  }

  renderSourceData = ({ id: sourceId, booked = 0, limit }) => {
    const { classes, onChange, onBlur, onFocus, id } = this.props
    const isFull = booked === limit
    const fullClass = isFull && classes.full

    return (
      <TableCell
        numeric
        key={sourceId}
        padding='none'
        className={cn(classes.tableCell, fullClass)}
      >

        <TextField
          value={booked}
          onBlur={onBlur({ id, sourceId, key: 'booked', limit })}
          padding='none'
          onFocus={onFocus}
          onChange={onChange({ id, sourceId, key: 'booked' })}
          className={classes.sourceField}
          inputProps={{
            className: cn(classes.sourceInput, fullClass)
          }}
        />
        /
        <TextField
          value={limit}
          onBlur={onBlur({ id, sourceId, key: 'limit' })}
          padding='none'
          onFocus={onFocus}
          onChange={onChange({ id, sourceId, key: 'limit' })}
          className={classes.sourceField}
          inputProps={{
            className: cn(classes.sourceInput, fullClass)
          }}
        />
        
      </TableCell>
    )
  }

  render() {
    const { sourcesData } = this.props

    return sourcesData.map(this.renderSourceData)
  }
}



// WEBPACK FOOTER //
// ./src/components/BigCalendar/components/SourcesCells/SourcesCells.js